import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isNative } from '@bubble-ui/util-platform';
var getDefaultStyleSheet = _ref => {
  var {
    colorToken,
    colorTokenArgs,
    designContext,
    labelGap,
    separatorMinWidthBeforeAndAfterLabel
  } = _ref;
  return {
    rootStyle: {
      alignItems: 'center',
      flexDirection: 'row',
      gap: labelGap
    },
    separatorWrapperStyle: {
      flexGrow: 1,
      flexShrink: 1,
      minWidth: separatorMinWidthBeforeAndAfterLabel
    },
    separatorStyle: _objectSpread(_objectSpread({}, isNative ? {
      borderTopWidth: 1
    } : {
      borderWidth: '1px 0 0 0'
    }), {}, {
      borderTopColor: designContext.get(colorToken, colorTokenArgs).toString(),
      width: '100%'
    })
  };
};
export { getDefaultStyleSheet };
//# sourceMappingURL=getDefaultStyleSheet.js.map